<template>
  <RevCard class="h-full shadow-none">
    <div
      class="relative flex h-full flex-col"
      :class="[$style.skeletonCardContainer]"
    >
      <div
        class="flex max-w-full grow content-start justify-center gap-8 p-16 flex-col-reverse"
        :class="[$style.skeletonCardWrapper]"
      >
        <!-- Info -->
        <div class="flex grow flex-col items-start gap-6 my-8">
          <RevSkeleton height="20px" shape="line" width="136px" />
          <RevSkeleton height="12px" shape="line" width="44px" />
          <RevSkeleton height="20px" shape="line" width="92px" />
        </div>

        <!-- Image -->
        <div class="flex flex-col items-center justify-center shrink-0">
          <RevSkeleton
            class="mb-20"
            height="128px"
            shape="rectangle"
            width="128px"
          />
        </div>
      </div>
    </div>
  </RevCard>
</template>

<script lang="ts" setup>
import { RevCard } from '@ds/components/Card'
import { RevSkeleton } from '@ds/components/Skeleton'
</script>

<style module>
.skeletonCardContainer {
  container-type: inline-size;
  container-name: product-card-skeleton;
}

.skeletonCardWrapper {
  min-height: 324px;
}

@container product-card-skeleton (width > 326px) {
  .skeletonCardWrapper {
    min-height: auto;
    flex-direction: row-reverse;
  }
}
</style>
